import { createFileRoute, retainSearchParams } from "@tanstack/react-router"
import { fallback, zodValidator } from "@tanstack/zod-adapter"
import { z } from "zod"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { CompetitorProductSortField, SortingOrder } from "@/graphql/codegen/graphql"
import CompetitorProductsContainer from "@/screens/ManageProducts/components/CompetitorProducts/containers/CompetitorProductsContainer"

const competitorProductsSearchSchema = z.object({
  query: fallback(z.string().optional().default(""), ""),
  distributorIds: z.array(z.string()).optional(),
  field: fallback(z.nativeEnum(CompetitorProductSortField), CompetitorProductSortField.ProductName),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Asc),
})

export const Route = createFileRoute("/app/admin/manage-products/_layout/competitor-products")({
  validateSearch: zodValidator(competitorProductsSearchSchema),
  search: {
    middlewares: [retainSearchParams(["query", "distributorIds", "field", "order"])],
  },
  component: () => (
    <PermissionContentWrapper
      permissions={[
        PermissionActionType.EQUIVALENT_MAINTENANCE,
        PermissionActionType.VENDOR_VIEW,
        PermissionActionType.VENDOR_MAINTENANCE,
      ]}
    >
      <CompetitorProductsContainer />
    </PermissionContentWrapper>
  ),
})
